import { Stack } from "expo-router"

export default () => {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={{ headerShown: false, animation: "none" }}
      />
      <Stack.Screen
        name="search/index"
        options={{ headerShown: false, animation: "fade" }}
      />
      <Stack.Screen
        name="import/index"
        options={{ headerShown: false, animation: "fade" }}
      />
      <Stack.Screen
        name="search/[placeId]"
        options={{ headerShown: false, animation: "none" }}
      />
      <Stack.Screen
        name="marketdata/qualitativefeedback"
        options={{
          headerShown: false,
          presentation: "fullScreenModal",
        }}
      />
      <Stack.Screen
        name="marketdata/regionsearch"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  )
}
